import React, { PureComponent } from 'react';
import { Loader, Colors } from '@inplayer-org/inplayer-ui';

// images
import paymentsIcon from 'assets/pics/icons/payments.svg';

// utils
import formatNumber from 'utils/formatNumber';

// types
import { ReportInformation } from 'ducks/merchantDucks/reports/types';
import { FetchReportParams, LoadReportsCommonParams } from 'ducks/merchantDucks/reports/actions';

// components
import AnalyticsInfoBox from 'pages/MerchantPages/Analytics/components/AnalyticsInfoBox';

export const PAYMENTS = 3;

interface Props {
  reportInformation: ReportInformation;
  active: boolean;
  startDate: string | number;
  endDate: string | number;
  interval: string;
  lineChart: boolean;
  color: string;
  loadReportInformations: (params: LoadReportsCommonParams) => any;
  loadRevenuePerCurrency: (params: LoadReportsCommonParams) => any;
  fetchReport: (params: FetchReportParams) => any;
  handleIconClick: (icon: number) => any;
}

export class PaymentsInfoBox extends PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    const { active: prevActive, startDate: prevStartDate, endDate: prevEndDate } = prevProps;
    const {
      fetchReport,
      loadReportInformations,
      loadRevenuePerCurrency,
      active,
      startDate,
      endDate,
      interval,
      lineChart,
    } = this.props;

    if (active && (prevActive !== active || prevStartDate !== startDate || prevEndDate !== endDate)) {
      fetchReport({ icon: PAYMENTS, startDate, endDate, interval, lineChart });

      const params = { startDate, endDate };
      loadReportInformations(params);
      loadRevenuePerCurrency(params);
    }
  }

  handleIconClick = () => {
    const { handleIconClick } = this.props;
    handleIconClick(PAYMENTS);
  };

  renderContent = () => {
    const {
      reportInformation: { numberOfPayments, isFetching },
    } = this.props;

    if (isFetching) {
      return <Loader color={Colors.white} />;
    }

    return <h6>Total: {formatNumber(numberOfPayments)}</h6>;
  };

  render() {
    const { active, color } = this.props;
    return (
      <AnalyticsInfoBox
        title="Payments"
        color={color}
        icon={paymentsIcon}
        active={active}
        handleIconClick={this.handleIconClick}
        renderContent={this.renderContent}
      />
    );
  }
}

export default PaymentsInfoBox;
